import React, { useState } from 'react'
import { faEdit, faUnlink } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Divider, message, Popconfirm, Tooltip } from 'antd'

import EditServiceVehicleModal from './EditServiceVehicleModal'
import ListItemCard from '../../../components/ListItemCard'

import { deleteServiceVehicle } from '../services'
import { handleError } from '../../../helpers'

export default function ServiceVehicleCard({ serviceVehicle, reload }) {
	const [showEditModal, setShowEditModal] = useState(false)

	const handleDelete = () => {
		deleteServiceVehicle(serviceVehicle.id)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(handleError)
	}

	return (
		<React.Fragment>
			<ListItemCard>
				<div className='float-right'>
					<Tooltip title="Editar" onClick={() => setShowEditModal(true)}>
						<FontAwesomeIcon className='text-link' icon={faEdit} />
					</Tooltip>
					<Divider type="horizontal" className='my-5' />
					<Tooltip title="Desasociar" placement='bottom'>
						<Popconfirm
							title="Esta acción no se puede revertir"
							okText="Desasociar"
							cancelText="Cancelar"
							okButtonProps={{ danger:true }}
							onConfirm={handleDelete}
						>
							<FontAwesomeIcon className='text-link' icon={faUnlink} />
						</Popconfirm>
					</Tooltip>
				</div>
				<p className='bold mb-3'>
					{serviceVehicle.vehicle.name}{" "}
					<small>(CC {serviceVehicle.vehicle.placas})</small>
				</p>
				<p className='mb-0 text-muted small'>Tiempo planeado: {serviceVehicle.minutes_planned} minutos</p>
				<p className='mb-0 text-muted small'>
					Tiempo usado: {serviceVehicle.minutes_used} minutos | Kilometros: {serviceVehicle.kilometers_used} km
				</p>
			</ListItemCard>
			{ showEditModal && (
				<EditServiceVehicleModal 
					visible
					onClose={() => setShowEditModal(false)}
					serviceVehicle={serviceVehicle}
					reload={reload}
				/>
			)}
		</React.Fragment>
	)
}